'use strict';
/* jshint ignore:start */

var secureacceptance = {

	addNewCardEvent: function (contactPreferences) {
		var obj = {
			button_ID: 'secure-acceptance-submit',
			customer_contact_preferences: contactPreferences.customer_contact_preferences ? contactPreferences.customer_contact_preferences : '',
			event: 'Saved cards - add new card'
		};
		dataLayer.push(obj);
	}
};
module.exports = secureacceptance;
/* jshint ignore:end */
